var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('view', 'Debug'))?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"small":"","icon":""},on:{"click":_vm.debugDialog}},on),[_c('v-icon',[_vm._v("science")])],1)]}}],null,false,2196215531)},[_vm._v(" Debug dialog ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }